module.exports = __webpack_public_path__ + "assets/5b8aa4edcb858dc15a885f55b3780a9e.ttf";